/**
 * 实时线索主路由
 * 2017-11-9
 * Bai.Zhiming
 */
"use strict";
angular.module("realTimeCluesRouterModule", []).
config(["$stateProvider", function($stateProvider) {
    $stateProvider.
    state("front.plan.realtimeclues.plannedclues", { //计划性线索
        url: '/plannedclues',
        views: {
            "main@front.plan.realtimeclues": {
                template: "<div ui-view='main'></div>"
            }
        }
    }).
    state("front.plan.realtimeclues.suddenclues", { //突发性线索
        url: '/suddenclues',
        views: {
            "main@front.plan.realtimeclues": {
                template: "<div ui-view='main'></div>"
            }
        }
    });
}]);